import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import CuttingName from "../../components/cutting/CuttingDetail/CuttingName.tsx";
import {useLocationFormState} from "../../components/cutting/CuttingForm/CuttingUpdateForm";
import CuttingUpdateFormProvider from "../../components/cutting/CuttingForm/CuttingUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CuttingUpdateEditPage = () => {
    
    useTitle(t`Update Cutting`);

    const { cuttingId: id } = useParams();
    
    return (
        <Box data-testid="Cutting-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Cutting-update-title"
                    >
                        <Trans>Edit Cutting</Trans>:  <CuttingName id={id}/>
                    </Typography>
                    <CuttingUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default CuttingUpdateEditPage;
